package one.healthium.login.di

import one.healthium.login.ui.login.LoginViewModel
import one.healthium.login.ui.silentLogin.SilentLoginViewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module


val loginModule = module {
    viewModelOf(::LoginViewModel)
    viewModelOf(::SilentLoginViewModel)
}